var _path, _rect;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgButtonGooglePlayLogo = function SvgButtonGooglePlayLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 42 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m25.62 16.162-13.811-7.91-.003-.001c-.328-.184-.583-.247-.774-.251l11.39 11.383 3.197-3.22ZM10.16 8.724c-.027.12-.043.256-.043.406v22.1c0 .217.033.404.084.56l11.381-11.56L10.159 8.724ZM31.156 19.45l-.008-.005-4.463-2.652-3.43 3.446 3.354 3.547 4.553-2.476c.58-.337.736-.694.736-.929 0-.235-.157-.594-.742-.931ZM11.07 32.516l11.342-11.427 3.125 3.3-13.709 7.907c-.31.136-.56.203-.758.22Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 39,
    rx: 5.5,
    stroke: "currentColor"
  })));
};

export default SvgButtonGooglePlayLogo;